/**
 * Created by orenm on 12/10/2014.
 */

define(function (require) {
    "use strict";

    var Template = require("connection-templates/expandedArticleView.tmpl");


    var ExpandedArticleView;
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        ExpandedArticleView = Marionette.ItemView.extend({
            template: Template,
            ui: {
                knowledgePack: ".knowledge-pack"
            }
        });
    });

    return ExpandedArticleView;
});